import { createSignal } from '@react-rxjs/utils';
import { bind } from '@react-rxjs/core';
import type { ReservationDescriptor } from '../../services/reservations';

export const [setReserveDialog$, setReserveDialog] = createSignal<boolean>();

export const [useReserveDialog, dialog$] = bind(setReserveDialog$, false);

export const [setEditedReservation$, setEditedReservation] =
  createSignal<ReservationDescriptor | null>();

export const [useEditedReservation, editedReservation$] = bind(
  setEditedReservation$,
  null
);
